import { Navigate, useLocation } from "react-router-dom";
import { isTokenValid, getToken } from "@/utils/jwt";
import type { ReactNode } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = getToken();
  const isValid = isTokenValid(token);
  const location = useLocation();

  if (!isValid) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
